import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { userService } from "../../services";
import { IIdentity } from "../../customTypings/user/Identity";

export const useUserData = () => {
    const params = useParams();
    const [user, setUser] = useState<IIdentity | null>(null);
    const [color, setColor] = useState("");
    const [userInteraction, setUserInteraction] = useState(false);

    useEffect(() => {
        userService
            .getById(params.userId ?? "")
            .then((userFromApi) => setUser(userFromApi));
        userService
            .getColor(params.userId ?? "")
            .then((color) => setColor(color));
    }, [params.userId]);

    useEffect(() => {
        if (userInteraction) {
            userService
                .getById(params.userId ?? "")
                .then((userFromApi) => setUser(userFromApi));
            userService
                .getColor(params.userId ?? "")
                .then((color) => setColor(color));
        }
        setUserInteraction(false);
    }, [params.userId, userInteraction]);

    const refreshUserData = () => {
        setUserInteraction(true);
    };

    return {
        user,
        color,
        refreshUserData
    };
};
